exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] .activity-log-filters{margin-bottom:10px}.activity-log-filters label{font-weight:600}[dir] .activity-log-filters label{margin-bottom:2px}.activity-log-actor-search{position:relative}.activity-log-actor-suggestions{position:absolute;z-index:20;width:100%;max-height:200px;overflow-y:auto;list-style:none}[dir] .activity-log-actor-suggestions{background:#fff;border:1px solid #ddd;margin:0;padding:0;box-shadow:0 2px 6px rgba(0,0,0,.15)}[dir] .activity-log-actor-suggestions li{padding:6px 10px;cursor:pointer}[dir] .activity-log-actor-suggestions li:hover{background:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40988d2d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/activityLog.vue
// module id = 985
// module chunks = 0